<template>
  <div id="app" @click="all()">
	<div v-if="maintenance=='true'" class='maintenance'>
			<div class="cotent">
				<icon file="alert-triangle" :size="40" />
            	<span class="label" >Application en maintenance, veuillez nous excuser pour la gêne occasionnée.</span>
			</div>	
		</div>
    <div class="main" v-if="is_connected">
      <div class="app-content" v-if="$route.name != 'print'">
        <div class="menu">
          <router-link
            :to="{ name: 'home' }"
            title="Projets"
            class="link active"
            ><icon class="main-icon" file="search" :size="32"
          /></router-link>

			<suggestions-modal v-slot="{ toggle }">
				<button class="link" @click="toggle()">
					<div>
						<icon class="main-icon" file="message-square" :size="32" />
						<div class="icon-text">
							Suggestions
						</div>
					</div>
				</button>
			</suggestions-modal>

			<div v-if ="env!='production'" class = "env" :class="env"> {{ env }} </div>

			<div class="bottom">
			<div title="Déconnexion" class="link" @click="logout()">
				<icon file="log-out" :size="32" />
			</div>
			</div>

        </div>

        <router-view />

        <window-new-study />
      </div>

      <print v-else />

      <notifications-group />

      <div v-if="app.ready != 'ready'" class="entering">
        <icon file="loader" :size="32" />Chargement en cours...
      </div>
    </div>

    <login v-else />

    <window-error-browser />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Bus } from "@/Bus";
import WindowNewStudy from "@/components/windows/window-new-study";
import WindowErrorBrowser from "@/components/windows/window-error-browser";
import Login from "@/components/login";
import Print from "@/components/study/print";
import NotificationsGroup from "./components/global/notifications-group.vue";
import SuggestionsModal from "./components/global/suggestions-modal.vue";

export default {
	name: "app",
	data: function () {
		return {
			show_apps: false,
			show_login: false,
			env: process.env.VUE_APP_ENVIRONMENT.toUpperCase(),
			maintenance: process.env.VUE_APP_MAINTENANCE
		};
	},
	computed: {
		...mapGetters(["app", "is_connected","study" ])
	},
	watch: {
		$route: function () {
			if (this.is_connected) {
				this.load_by_route();
			}
		},
		is_connected: function (new_value, old_value) {
			if(new_value && old_value == false && Object.keys(this.app.app_parameters) == 0)
				this.$store.dispatch("init_app");
		}
	},
	methods: {
		logout: async function () {
			await this.$store.dispatch("logout");
			this.$router.push({ name: "home" });
			this.show_login = true;
		},
		all: function () {
			Bus.$emit("global-click");
			this.show_apps = false;
		},
		load_by_route: async function () {
			const self = this;

			if (this.is_connected) {
				// HOME
				if (this.$route.name == "home") {
					this.$store.dispatch("save_required");
					this.$store.commit("SET_STUDY_STATE", { active_study: false });
					this.$store.dispatch("set_ready", { ready: "ready" });
					this.$store.dispatch("search_projects");
				}

				// STUDY EDITOR
				else if (this.$route.name == "study" || this.$route.name == "print") {
					// console.log("load_by_route - dispatch action load_study");
					await this.$store.dispatch("load_study", {
						id: this.$route.params.id,
						callback: function () {
							// console.log("load_by_route - load_study callback");
							self.$store.dispatch("set_ready", { ready: "ready" });
						}
					});

					// OTHERS
				} else this.$store.dispatch("set_ready", { ready: "ready" });
			} else this.$store.dispatch("set_ready", { ready: "ready" });
		},
		init: function () {
			const self = this;

			if (this.check_browser()) {
				this.$nextTick(function () {
				// console.log("app.vue - init() - authenticating");
				
					if (localStorage.getItem("lli-email")) {
						localStorage.removeItem("lli-email");
					}
					if (localStorage.getItem("lli-password")) {
						localStorage.removeItem("lli-password");
					}

					if (localStorage.getItem("lli-token")) {
						self.$store.dispatch("login", {
							token: localStorage.getItem("lli-token"),
							callback: function () {
								// console.log("app.vue - init() - authenticating callback");
								/* if (self.is_connected) {
                  self.$store.dispatch("init_app");
                } */
							}
						});
					} else {
						this.show_login = true;
						self.$store.dispatch("set_ready", { ready: "ready" });
					}
				});
			} else
				this.$store.dispatch("set_window", { name: "window-error-browser" });
		},
		check_browser: function () {
			return true;
		}
	},
	mounted: function () {
		const self = this;

		Bus.$on("logged", async function () {
			await self.$store.dispatch("load_lists");
			await self.load_by_route();
			self.show_login = false;
		});

		// console.log('Mounted - calling init()');
		this.init();

		if(this.maintenance =="true")
			this.logout();
	},
	components: { Login, WindowNewStudy, Print, WindowErrorBrowser, NotificationsGroup, SuggestionsModal }
};
</script>
<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Fira+Sans:400,500')
@import './assets/css/app'
@import './assets/css/box'
@import './assets/css/grid'
@import './assets/css/scrollbar.css'
@import './assets/css/fonts/volte.css'
@import '~vue-context/dist/css/vue-context.css';

.maintenance
	margin: auto;
	background-color: white;
	display: flex;
	height: 100%;
	width: 100%;
	position: fixed;
	z-index: 1111;
	opacity: 0.9;
	text-align: center
	font-size: x-large
	padding-top: 32px
	.cotent
		margin: auto
		.label
			padding 8px

.env
	color white
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	color: rgb(255, 255, 255);
	height: 88px;
	width: 88px;
	border-radius: 4px;

	// position: absolute;
	// left: 8px;
	// bottom: 8px;


.LOCAL {
  background-color: #c44043;
  opacity: 0.8;
}
.DEV {
  background-color: #2196f3;
  opacity: 0.8;
}

:root
	font-size 62.5%
*
	margin 0
	padding 0
	position relative
	box-sizing border-box
	-webkit-tap-highlight-color rgba(0,0,0,0)
	touch-action manipulation
::selection
	background-color darken(main_color, 25%)
	color #fff
html, body, #app, .main, .container, .menu, .box, .scroll-wrap, .scroll, .scroll-content
	height 100%
body
	// font-family 'Montserrat', arial, sans-serif
	font-family 'Fira Sans', sans-serif
	font-size 1.4rem
	font-weight 400
	line-height 1.3em
	color dark
	background-color dark
	// overflow hidden
strong
	// font-weight 500

a
	color inherit
	text-decoration none
	&:hover
		text-decoration none
#app
	color #333
	background dark
	.app-content
		height 100%
		padding 16px


#app.loading
	.menu
		.link.active
			.main-icon
				display none
			.loading-icon
				display block
.menu
	float left
	width 88px
	.bottom
		position absolute
		left 0
		bottom 0
		margin-bottom 0
		.link:last-child
			margin-bottom 0
	.link
		display flex
		flex-direction column
		justify-content: center
		align-items center
		margin 0 0 8px 0
		width 88px
		height 88px
		padding ((@width - 32) / 2)
		background gray
		border none
		border-radius radius
		color #fff
		cursor pointer
		&:hover
			background-color darken(gray, 10%)
		&.active
			background-color main_color
		&.apps
			margin 0 0 32px 0
			&:after
				content ''
				position absolute
				left 16px
				right 16px
				bottom -16px
				height 1px
				background gray
				opacity 0.5
			&.show-apps
				background-color light
				color dark
		.loading-icon
			display none
			animation rotate 1s infinite linear
			margin 0 auto
		.icon-text
			font-size 12px
			font-weight 500
			margin-top 5px

	.apps-menu
		position absolute
		left 100px
		top -4px
		width (128px * 2 + 32px)
		height (@width + 24px)
		padding 16px
		background light
		z-index 2000
		border-radius radius
		box-shadow 0 0 8px gray
		&:after
			content ''
			position absolute
			left -8px
			top 40px
			width 0
			height 0
			border-style solid
			border-width 8px 8px 8px 0
			border-color transparent light transparent transparent
		.apps-menu-content
			height 100%
			.apps-menu-wrap
				height 100%
		.app
			float left
			width 128px
			height (48px + 32px + 4px + 32px)
			padding 16px 4px
			line-height 24px
			text-align center
			cursor pointer
			border-radius radius
			&:hover
				box-shadow inset 0 0 0 1px darken(light, 10%)
			.app-icon
				display block
				height 48px
				padding 4px 0
				.icon
					display inline-block
				img
					max-height 100%
					max-width 100%
			.app-name
				margin 4px 0 0 0
				height 32px
				line-height 16px
				font-weight 500
				overflow hidden
				display flex
				align-items center
				justify-content center


@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)


.container
	float right
	width calc(100% - 88px - 16px)
	.left
		float left
		width calc(100% - 350px - 16px)
		height 100%
	.right
		float right
		width 350px
		height 100%
.notifications
	position fixed
	right 16px
	top 16px
	z-index 10005
.notifications-enter, .notifications-leave-to
	opacity 0
	transform translateX(100%)
.notifications-leave-active
	position absolute
.start-loading
	position fixed
	left 0
	top 0
	right 0
	bottom 0
	background dark
	z-index 5000
	color #fff
	.text
		position absolute
		left 50%
		top 50%
		transform translate(-50%, -50%)
		text-align center
		color #999
		font-weight 500
		text-transform uppercase
		font-size 1.2rem
		&.error
			color red
		.icon
			margin 0 0 8px 0
			&.loader
				animation rotate 1.5s infinite linear

.entering
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	display flex
	flex-direction column
	align-items center
	justify-content center
	background-color dark
	z-index 100000
	color #fff
	font-weight 500
	text-transform uppercase
	color alpha(#fff, 75%)
	cursor progress
	.icon
		margin-bottom 16px
		animation rotate 1.5s infinite linear


@media (min-width: 0)
	html body
		font-family  'Fira Sans', sans-serif
		p
			margin-block-start 0
			margin-block-end 0
		.col
			flex initial
		.row
			margin-left 0
			.col
				padding-left 8px
				float initial
</style>
